import * as Sentry from "@sentry/react"
import { OLD_APP_URL } from "app/api/config"
import { authenticate, authorize, logout } from "app/api/oauth"
import { getAccessToken, storeAccessToken, storeIdToken } from "app/localStorage/token"
import { createRoot } from "react-dom/client"
import { Shell } from "./Shell"
import { decideBetaStart, finishLogin, oldAppUrl } from "./start"
import "./tokens.css"

// Same GlitchTip project and personal-data baseline as src/index.tsx, tagged so beta errors are told apart
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT?.toLowerCase(),
    tracesSampleRate: 0,
    initialScope: { tags: { app: "beta" } },
    dataCollection: {
      userInfo: false,
      cookies: false,
      urlQueryParams: false,
      httpBodies: [],
      httpHeaders: { request: { allow: ["user-agent", "content-type"] }, response: false },
    },
  })
}

switch (decideBetaStart(location.pathname, getAccessToken(), Date.now(), location.hash)) {
  case "callback":
    finishLogin({
      authenticate,
      storeAccessToken,
      storeIdToken,
      logout,
      report: error => Sentry.captureException(error),
      done: () => location.replace("/"),
    })
    break
  case "login":
    authorize()
    break
  case "old-app":
    location.replace(oldAppUrl(OLD_APP_URL))
    break
  default:
    createRoot(document.getElementById("beta-root")!).render(<Shell />)
}
